import React, { useState, useEffect } from "react";
import {
  Page,
  Text,
  View,
  Svg,
  Path,
  Image,
  Document,
  StyleSheet,
  Link,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  document: {
    border: 0,
  },
  page: {
    flexDirection: "row",
    border: 0,
    paddingHorizontal: 40,
    paddingVertical: 30,
  },
  section: {
    margin: 0,
    padding: 0,
    // flexGrow: 1
  },
  image: {
    height: 100,
    width: 100,
    borderRadius: 50,
  },
  sidebar: {
    flexBasis: 180,
    // backgroundColor: '#333',
    paddingRight: 10,
  },
  main: {
    width: 350,
  },
  photo: {
    borderTopLeftRadius: 50,
    borderTopRightRadius: 50,
    borderBottomRightRadius: 50,
    borderBottomLeftRadius: 50,
    height: 68,
    width: 68,
  },
  sectionTitle: {
    fontSize: 14,
    color: "#b58e58",
    fontWeight: 400,
    marginBottom: 15,
  },
  sectionGap: {
    marginTop: 15,
  },
  infoBlock: {
    marginBottom: 8,
  },
  label: {
    fontSize: 10,
    color: "#1e2532",
  },
  text: {
    fontSize: 10,
    color: "#828ba2",
    lineHeight: 1.7,
  },
  links: {
    color: "#b58e58",
    textDecoration: "none",
  },
  name: {
    fontSize: 22,
    fontWeight: 700,
  },
  designation: {
    fontSize: 11,
    fontWeight: 500,
    marginTop: 10,
    color: "#828ba2",
  },
  flex: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  titleSm: {
    fontSize: 12,
    color: "#1e2532",
  },
});

function PDFFile({
  avater,
  firstName,
  lastName,
  email,
  phone,
  jobTitle,
  country,
  city,
  address,
  postalCode,
  drivingLicense,
  nationality,
  placeOfBirth,
  dateOfBirth,
  professionalSummery,
  interest,
  skills,
  links,
  employmentHistory,
  educations,
}) {
  const [hasLink, setHasLink] = useState(false);
  const [hasEducation, setHasEducation] = useState(false);
  const [hasHistory, setHasHistory] = useState(false);

  useEffect(() => {
    employmentHistory.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== "") {
          setHasHistory(true);
        }
      });
    });
  }, [employmentHistory, hasHistory]);

  useEffect(() => {
    educations.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== "") {
          setHasEducation(true);
        }
      });
    });
  }, [educations]);

  useEffect(() => {
    links.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== "") {
          setHasLink(true);
        }
      });
    });
  }, [links, hasLink]);

  const skillArr = skills.split(",");

  const marker = (
    <Svg
      style={{ marginLeft: 15, marginRight: 2 }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
      width="10"
      height="10"
    >
      <Path
        fill="#d1d1d1"
        d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
      />
    </Svg>
  );

  return (
    <Document style={styles.document} title="hello">
      <Page size="A4" style={styles.page}>
        <View style={styles.sidebar}>
          <Image style={styles.photo} src={avater} />
          {(address ||
            city ||
            postalCode ||
            country ||
            phone ||
            email ||
            dateOfBirth ||
            placeOfBirth ||
            nationality ||
            drivingLicense) && (
            <View>
              <Text style={[styles.sectionTitle, styles.sectionGap]}>
                Details
              </Text>
              {(address || city || postalCode || country) && (
                <View style={styles.infoBlock}>
                  <Text style={[styles.label, { marginBottom: 4 }]}>
                    Address
                  </Text>
                  {address && <Text style={styles.text}>{address},</Text>}
                  {(postalCode || city) && (
                    <Text style={styles.text}>
                      {city} {postalCode},
                    </Text>
                  )}
                  {country && <Text style={styles.text}>{country}</Text>}
                </View>
              )}
              {phone && (
                <View style={styles.infoBlock}>
                  <Text style={[styles.label, { marginBottom: 4 }]}>Phone</Text>
                  <Text style={styles.text}>{phone}</Text>
                </View>
              )}
              {email && (
                <View style={styles.infoBlock}>
                  <Text style={[styles.label, { marginBottom: 4 }]}>Email</Text>
                  <Text style={styles.text}>{email}</Text>
                </View>
              )}
              {(dateOfBirth || placeOfBirth) && (
                <View style={styles.infoBlock}>
                  <Text style={[styles.label, { marginBottom: 4 }]}>
                    Date / Place of birth
                  </Text>
                  {dateOfBirth && (
                    <Text style={styles.text}>{dateOfBirth}</Text>
                  )}
                  {placeOfBirth && (
                    <Text style={styles.text}>{placeOfBirth}</Text>
                  )}
                </View>
              )}
              {nationality && (
                <View style={styles.infoBlock}>
                  <Text style={[styles.label, { marginBottom: 4 }]}>
                    Nationality
                  </Text>
                  <Text style={styles.text}>{nationality}</Text>
                </View>
              )}
              {drivingLicense && (
                <View style={styles.infoBlock}>
                  <Text style={[styles.label, { marginBottom: 4 }]}>
                    Driving License
                  </Text>
                  <Text style={styles.text}>{drivingLicense}</Text>
                </View>
              )}
            </View>
          )}

          {hasLink ? (
            <View>
              <Text style={[styles.sectionTitle, styles.sectionGap]}>
                Links
              </Text>
              {links.map((link, index) => (
                <View key={index} style={styles.infoBlock}>
                  <Link src={link.value} style={styles.links}>
                    <Text style={[styles.text, styles.links]}>
                      {link.title}
                    </Text>
                  </Link>
                </View>
              ))}
            </View>
          ) : null}
          <Text></Text>

          {skills && (
            <View>
              <Text style={[styles.sectionTitle, styles.sectionGap]}>
                Skills
              </Text>
              <View style={styles.infoBlock}>
                {skillArr.map((skill, index) => (
                  <View key={index} style={styles.infoBlock}>
                    <Text style={[styles.text, styles.label]}>
                      {skill.trim()}
                    </Text>
                  </View>
                ))}
              </View>
            </View>
          )}
          {interest && (
            <View>
              <Text style={[styles.sectionTitle, styles.sectionGap]}>
                Interest
              </Text>
              <View style={styles.infoBlock}>
                <Text style={[styles.text, styles.label]}>{interest}</Text>
              </View>
            </View>
          )}
        </View>
        <View style={styles.main}>
          <View>
            {(firstName || lastName || jobTitle) && (
              <View>
                <Text style={styles.name}>
                  {firstName} {lastName}{" "}
                </Text>
                <Text style={styles.designation}>{jobTitle}</Text>
              </View>
            )}
          </View>
          <View>
            {professionalSummery && (
              <View style={styles.sectionGap}>
                <Text style={[styles.sectionTitle, { marginTop: 22 }]}>
                  Profile
                </Text>
                <Text
                  style={[styles.text, { lineHeight: 1.7, marginBottom: 5 }]}
                >
                  {professionalSummery}
                </Text>
              </View>
            )}
          </View>

          {hasHistory ? (
            <View style={styles.sectionGap}>
              <Text style={styles.sectionTitle}>Employment History</Text>
              {employmentHistory.map((history, index) => (
                <View key={index} style={styles.sectionGap}>
                  <Text style={styles.titleSm}>
                    {history.prevDesignation}
                    {history.prevDesignation && history.prevCompany ? ", " : ""}
                    {history.prevCompany}
                  </Text>
                  <View
                    style={[styles.flex, { marginTop: 5, marginBottom: 8 }]}
                  >
                    <Text style={{ fontSize: 10, color: "#1e2532" }}>
                      {history.startDate ? history.startDate : ""} to{" "}
                      {history.endDate ? history.endDate : ""}
                    </Text>
                    {marker}
                    <Text style={{ fontSize: 10, color: "#828ba2" }}>
                      {history.jobLocations ? history.jobLocations : ""}
                    </Text>
                  </View>
                  {history.JobDescription && (
                    <Text style={styles.text}>{history.JobDescription}</Text>
                  )}
                </View>
              ))}
            </View>
          ) : null}

          {hasEducation ? (
            <View style={styles.sectionGap}>
              <Text style={styles.sectionTitle}>Education</Text>
              {educations.map((education, index) => (
                <View key={index} style={styles.sectionGap}>
                  <Text style={styles.titleSm}>
                    {education.instituteName}, {education.degree}
                  </Text>
                  <View
                    style={[styles.flex, { marginTop: 5, marginBottom: 8 }]}
                  >
                    <Text style={{ fontSize: 10, color: "#1e2532" }}>
                      {education.passingYear}
                    </Text>
                    {marker}
                    <Text style={{ fontSize: 10, color: "#828ba2" }}>
                      {education.degreeLocation}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          ) : null}

          <Text></Text>
        </View>
      </Page>
    </Document>
  );
}

export default PDFFile;
